<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-5">
<div class="heading heading-with-title heading-without-image" id="chapter-5-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">5</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-5-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">P</span>eggy Dobbs was sitting in the witness interview room at Marlow Police Station. Her hands shook as she reached out for the cup of tea Fleming had brought her. Her face was ashen and bloodshot eyes peered at him anxiously.</p>
<p class="subsq">Fleming sat opposite her and placed his cup on the table. ‘Tea okay?’ he asked politely. ‘I’m afraid it’s just from the vending machine.’</p>
<p class="subsq">‘Y… yes,’ Peggy stammered.</p>
<p class="subsq">‘I know you’ve had a bit of a shock. You’re here voluntarily as a witness. You can go at any time if you don’t feel up to answering any questions. But it is important we do this as soon as we can. Memory tends to fade if we leave things too long.’</p>
<p class="subsq">Peggy laughed nervously. ‘Goodness, my memory isn’t brilliant at the best of times. I often wander up the stairs and then ask myself what it is I’ve come up for. But you go ahead and ask what you want.’ Peggy’s hands were still shaking when she lifted her cup to take a sip of tea and some spilled onto the table. ‘Oh dear, look what I’ve done now. I can’t stop shaking.’</p>
<p class="subsq">‘Don’t worry,’ Fleming said gently. ‘You sure you’re all right?’</p>
<p class="subsq">‘Yes… yes, of course. I’m fine.’ She blew steam from her cup and took a sip. She seemed to feel more at ease in Fleming’s presence.</p>
<p class="subsq">‘Perhaps you could just talk me through what happened – what you saw. Take your time. I know it must all be distressing for you.’</p>
<p class="subsq">Peggy smiled weakly. ‘I set off from home to go to the boat – Mr Nielson’s boat. He wanted me to do some cleaning…’</p>
<p class="subsq">‘When did he ask you?’</p>
<p class="subsq">‘Oh, last night. He phoned to ask if I could come this morning before he set off for London.’</p>
<p class="subsq">‘What time was that?’</p>
<p class="subsq">‘Not long before six. Yes, that would be it. I was about to put my dinner on. I always have it around six.’</p>
<p class="subsq">‘How did he sound? I mean – did he sound his usual self?’</p>
<p class="subsq">‘I’m… I’m not sure…’</p>
<p class="subsq">‘Did he sound anxious… in a hurry? Could you sense if anyone was with him? Hear any sounds in the background that might have been caused by another person?’</p>
<p class="subsq">‘No, he sounded perfectly normal. I couldn’t say I heard anyone else there.’</p>
<p class="subsq">‘How long had you known Mr Nielson?’ Fleming asked.</p>
<p class="subsq">‘About five years. I’ve cleaned for him all that time. I do his house and the boat.’</p>
<p class="subsq">‘What did he do for a living?’</p>
<p class="subsq">‘He owns a club in London – Nielson’s Cellar. He took it on when his father died – it was a car accident. He told me all about it some time back.’</p>
<p class="subsq">‘Did he get many regular visitors to the house or the boat that you know of?’</p>
<p class="subsq">‘People came and went all the time. He had lots of parties at the house.’</p>
<p class="subsq">‘Would you know any of these people?’</p>
<p class="subsq">‘Oh, no. I had no idea who his social contacts were, except…’</p>
<p class="subsq">‘Yes?’</p>
<p class="subsq">‘A couple of weeks ago there was a woman with him on the boat. Now what was it he called her…?’ Peggy’s eyes looked up at the ceiling as though for inspiration. ‘I told you my memory was bad.’ She frowned. ‘Sorry, I’m not good at remembering names.’</p>
<p class="subsq">‘Was it Emma?’ Fleming prompted.</p>
<p class="subsq">‘Yes! Yes, that’s it. Emma!’</p>
<p class="subsq">‘Had you seen her before – at the house maybe?’</p>
<p class="subsq">‘No, no I can’t say that I did.’</p>
<p class="subsq">‘Can you describe her?’</p>
<p class="subsq">‘Let me see now. She was probably medium height, blonde hair – about shoulder length. Attractive woman, maybe mid-forties. Seemed very classy.’</p>
<p class="subsq">Fleming formed a mental image in his mind. ‘Did you see anyone else on the towpath as you made your way to the boat?’</p>
<p class="subsq">‘Yes. There was a jogger. Startled the life out of me as he came running up behind me.’</p>
<p class="subsq">‘So, he was running towards the boat.’</p>
<p class="subsq">‘Goodness. How did you know that?’</p>
<p class="subsq">‘Because you were walking towards the boat and he came up behind you.’</p>
<p class="subsq">Peggy nodded. ‘I can see why you’re a detective, dear.’</p>
<p class="subsq">Fleming smiled at her naivety. ‘And he came back later – saw you just after you’d found the body?’</p>
<p class="subsq">‘Yes, he stopped and asked if I was all right. It was him who phoned the police. I was in too much of a state to do anything.’</p>
<p class="subsq">‘So, when you got to the boat, what did you find?’</p>
<p class="subsq">‘The cabin door was open so I thought Mr Nielson was down below. But it felt strange. There was no sign of life. No music playing. Mr Nielson always had music blaring when he was on the boat. I shouted down to tell him I was there, but there was no answer. I… I went down into the saloon. There were flies everywhere. Blood all over the seats and the floor. It was awful. I pushed open the door to the galley and… and there he was…’ Peggy shivered and began to cry.</p>
<p class="subsq">‘It’s okay, Mrs Dobbs. Take your time. I know this isn’t easy for you. But you’re doing fine. Can I get you some more tea?’</p>
<p class="subsq">‘Yes… yes, please,’ Peggy sobbed.</p>
<p class="subsq">Fleming put a reassuring hand on Peggy’s shoulder as he left to go to the vending machine. He returned shortly after with a fresh cup.</p>
<p class="subsq">‘Thanks,’ Peggy whispered. ‘You’re very kind.’</p>
<p class="subsq">‘So, after you found the body, you came straight back up on deck where the jogger saw you again?’</p>
<p class="subsq">‘That’s right… and he rang for the police.’</p>
<p class="subsq">‘Were there any lights on in the boat when you arrived?’</p>
<p class="subsq">‘I’m not sure. It’s all such a blur. I don’t think so.’</p>
<p class="subsq">‘Mrs Dobbs, you’ve been really brave and helpful. Thank you. There’s one final question. When was the last time you saw Mr Nielson alive?’</p>
<p class="subsq">‘It was a couple of nights ago. I was taking a walk along the towpath and I heard music from the boat. I didn’t stay but popped my head in to say hello.’</p>
<p class="subsq">‘Did he have anyone with him?’</p>
<p class="subsq">‘No… he was busy at the table in the saloon working on his laptop. He looked startled when I appeared, a bit distracted. That’s why I didn’t stay.’</p>
<p class="subsq">‘Thanks. There’s one more thing. We need to take your fingerprints and a DNA sample, if you don’t mind–’</p>
<p class="subsq">Peggy’s eyes widened in shock. ‘My goodness, why? You surely don’t think I had anything to do with it?’</p>
<p class="subsq">‘No, no, of course not,’ Fleming reassured her. ‘It’s so we can eliminate them from any other samples we find at the crime scene, that’s all.’</p>
<p class="subsq">‘Oh… I see.’</p>
<p class="subsq">‘Once you’ve finished your tea and we get that done, someone will run you home. Would you like a WPC to stay with you tonight?’</p>
<p class="subsq">‘That would be nice. If it’s not too much trouble…’</p>
<p class="subsq">‘No trouble at all, Mrs Dobbs. You take care now.’</p>
<p class="subsq">Walking back to his car, Fleming mulled over his priorities. Number one – he needed to trace the woman called Emma.</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">On her way home, Peggy Dobbs bit her bottom lip and frowned. She wondered if she had done the right thing in not mentioning the other phone call she’d received on the night of the murder…</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter005.vue?1329c240